import deriveLinkComponents from '../associations/derive-link-components';
import api from '../REST/api';
import OpportunityLink from './OpportunityLink';

const { Link, Links } = deriveLinkComponents(
  OpportunityLink,
  api.getOpportunity,
);

export { Link as OpportunityLink, Links as OpportunityLinks };
